// extracted by mini-css-extract-plugin
export var arrow = "style-module--arrow--3b1f0";
export var container = "style-module--container--da5ac";
export var description = "style-module--description--9f115";
export var title = "style-module--title--41555";